import Navbar from './components/navbar'
import Search from './components/search'
import Product from './components/product'
import Footer from './components/footer'
import Part4 from './components/part4'
import './style.css'

function App(){
    return(
    <div>
    <Navbar></Navbar>
    <Search></Search>
    <Product></Product>
    <Part4></Part4>
    <Footer />
  </div>)
}

export default App